<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>Medical Records Reports</h1>
          <p>Choose Report from Medical Records Report list </p>
      </div>
  </div>
</section>


<div id="w3l-appointment">
<section class="appointment-section section-gap">
  <div class="wrapper">
      <div class="d-grid doctor-appointment">
          <div class="appointment-form">
              <form action="#" method="post">
                  <div class="fields-grid">
                    <div class="styled-input">
                      <div class="appointment-form-field">
                          <a (click)="openDialog_0()"  style="cursor: grab;">1. Patient number doctors care by service</a>
                      </div>
                      <div class="appointment-form-field">
                        <a (click)="openDialog()" style="cursor: grab;" >2.Number of patients for every gender</a >
                     </div>
                     <div class="appointment-form-field">
                       <a (click)="openDialogSummary()" style="cursor: grab;" >3.Number of patients for every gender(Summary)</a >
                     </div>
                     <div class="appointment-form-field">
                            <a (click)="openDialog1()" style="cursor: grab;" >4.Number of patients by cancer type (details)</a >
                      </div>
                      <div class="appointment-form-field">
                          <a (click)="openDialog_4()" style="cursor: grab;" >5.Clinic Patient Status</a >
                      </div>
                      <div class="appointment-form-field">
                          <a (click)="MortalityDilaog()" style="cursor: grab;" >6.Mortality Report</a >
                      </div>
                      <div class="appointment-form-field">
                        <a (click)="PatienDateDilaog()" style="cursor: grab;" >7.Patient List From Date To Date</a >
                      </div>
                      <div class="appointment-form-field">
                        <a (click)="PatienCancerDilaog()" style="cursor: grab;" >8.Patient List From Date To Date By Cancer Type</a >
                      </div>
                      <div class="appointment-form-field">
                        <a (click)="PatienGovDilaog()" style="cursor: grab;" >9.Patient List From Date To Date By Governorate</a >
                      </div>
                      <div class="appointment-form-field">
                        <a (click)="PatienNatDilaog()" style="cursor: grab;" >10.Patient List From Date To Date By Nationality</a >
                      </div>
                      <div class="appointment-form-field">
                        <a (click)="openDialog_5()" style="cursor: grab;" >11.Patient's Examiniation from Date To Date</a>
                      </div>
                      <div class="appointment-form-field">
                        <a (click)="openDialog_10()" style="cursor: grab;">12.Patient's Visits</a>
                      </div>
                    </div>




                      <a href="Home">
                      <button type="button" class="theme-button btn" style="width: 83%;" name="Back">Home</button>
                      </a>
                      <div class="clear"> </div>
                  </div>
              </form>
          </div>

          <div class="registerimg">
              <img src="assets/images/report2.jpg" alt="" />
          </div>
      </div>
      <div class="clear"> </div>
  </div>
</section>
</div>


